import { TreeUtils } from './tree-utils';
import { MaterialTree } from '../models/material-tree';
import { ItemNode } from '../models/item';
import { BehaviorSubject } from 'rxjs';

export class TreeFilterHandler {

    filterSelectedItems?: ItemNode[] = [];

    private filterSubject = new BehaviorSubject<string>('')

    get filter$() {
        return this.filterSubject.asObservable();
    }

    get filterValue() {
        return this.filterSubject.value;
    }
    set filterValue(value: string) {
        this.filterSubject.next(value);
    }

    constructor(private materialTree: MaterialTree, private treeUtils: TreeUtils, private itemList) { }

    getAllIdValueFromObject(object) {
        const ids = [];
        JSON.stringify(object, (key, value) => {
            if (key === 'Id') { ids.push(value); }
            return value;
        });
        return ids;
    }

    applyFilter(collapse?: boolean) {
        const filterText = this.filterValue;
        const availableItems = (this.filterSelectedItems.length) ? this.filterSelectedItems : this.itemList;
        const matches = (filterText) ? this.filterVal(availableItems, filterText) : availableItems;
        const matchIds = this.getAllIdValueFromObject(matches);
        this.materialTree.treeControl.dataNodes.forEach(node => {
            node.visible = (matchIds.indexOf(node.Id) > -1);
        });
        if (filterText) {
            this.treeUtils.expandAll();
        }
        if (collapse) {
            this.treeUtils.collapseAll();
        }
    }

    private filterVal(arr, term) {
        const matches = [];
        if (!Array.isArray(arr)) {
            return matches;
        }
        arr.forEach(i => {
            if (i.Description && i.Description.toLowerCase().indexOf(term.toLowerCase()) > -1) {
                matches.push(i);
            }
            if (i.children) {
                const childResults = this.filterVal(i.children, term);
                if (childResults.length) {
                    matches.push(Object.assign({}, i, { children: childResults }));
                }
            }
        });
        return matches;
    }


    filterSelected(arr, selectedItems) { // prende solo i "padri"
        const matches = [];
        if (!Array.isArray(arr)) {
            return matches;
        }
        arr.forEach(i => {
            if (selectedItems.includes(i.Id)) {
                matches.push(i); // if i.selected ?
            }
            else if (i.children) {
                const childResults = this.filterSelected(i.children, selectedItems);
                if (childResults.length) {
                    matches.push(Object.assign({}, i, { children: childResults }));
                }
            }
        });
        return matches;
    }


    emptyFilter(e, status) {
        e.stopPropagation();
        this.filterValue = '';
        const collapse = (status == 'edit');
        this.applyFilter(collapse);
    }

}
